export const isBookingR2R = (booking) => {
  return Number(process.env.REACT_APP_RENT_TO_RENT_OWNER_ID) === Number(booking.property_owner_id)
}
